export default () => ({
  additionalItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    mb: '2px'
  }
});
